import React, { useEffect } from 'react';

const AdminPanel = () => {
  useEffect(() => {
    // Redirect to hosted Sanity Studio
    const projectId = process.env.NEXT_PUBLIC_SANITY_PROJECT_ID || process.env.REACT_APP_SANITY_PROJECT_ID || 'd8gvm4xl';
    window.location.href = `https://${projectId}.sanity.studio`;
  }, []);

  return (
    <div style={{ 
      height: '100vh', 
      display: 'flex', 
      flexDirection: 'column',
      alignItems: 'center', 
      justifyContent: 'center',
      fontFamily: 'var(--font-primary)',
      backgroundColor: 'var(--background-color)',
      color: 'var(--text-color)'
    }}>
      <h1>Redirecting to Sanity Studio...</h1>
      <p>If you're not redirected automatically, you can access your Sanity Studio at:</p>
      <p>
        <a 
          href={`https://${process.env.NEXT_PUBLIC_SANITY_PROJECT_ID || process.env.REACT_APP_SANITY_PROJECT_ID || 'd8gvm4xl'}.sanity.studio`}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: 'var(--primary-color)' }}
        >
          https://{process.env.NEXT_PUBLIC_SANITY_PROJECT_ID || process.env.REACT_APP_SANITY_PROJECT_ID || 'd8gvm4xl'}.sanity.studio
        </a>
      </p>
      <div style={{ marginTop: '2rem', padding: '1rem', backgroundColor: 'var(--card-bg-color)', borderRadius: '8px' }}>
        <h3>Alternative: Use Sanity CLI</h3>
        <p>You can also run the studio locally with:</p>
        <code style={{ 
          backgroundColor: 'var(--background-color)', 
          padding: '0.5rem', 
          borderRadius: '4px',
          display: 'block',
          marginTop: '0.5rem'
        }}>
          npx sanity start
        </code>
      </div>
    </div>
  );
};

export default AdminPanel;